import { render, staticRenderFns } from "./RegulationBControl.vue?vue&type=template&id=27fcac0d&scoped=true&"
import script from "./RegulationBControl.vue?vue&type=script&lang=js&"
export * from "./RegulationBControl.vue?vue&type=script&lang=js&"
import style0 from "./RegulationBControl.vue?vue&type=style&index=0&id=27fcac0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fcac0d",
  null
  
)

export default component.exports